// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a9-3";
export var contentContainer = "_a9-0";
export var editorContainer = "_a9-1";
export var quillInputForm = "_a9-2";
export var zoneDivider = "_a9-4";